export default {
  API_URL: process.env.API_BASE_URL || process.env.REACT_APP_API_BASE_URL,
  SLIMPAY_WS_URL: process.env.SLIMPAY_WS_URL || process.env.REACT_APP_SLIMPAY_WS_URL,
  AWS_AUTH_REGION: process.env.AWS_AUTH_REGION || process.env.REACT_APP_AWS_AUTH_REGION,
  AWS_AUTH_USER_POOL_ID: process.env.AWS_AUTH_USER_POOL_ID || process.env.REACT_APP_AWS_AUTH_USER_POOL_ID,
  AWS_AUTH_USER_POOL_WEBCLIENT_ID: process.env.AWS_AUTH_USER_POOL_WEBCLIENT_ID || process.env.REACT_APP_AWS_AUTH_USER_POOL_WEBCLIENT_ID,
  AWS_AUTH_FLOW_TYPE: process.env.AWS_AUTH_FLOW_TYPE || process.env.REACT_APP_AWS_AUTH_FLOW_TYPE,
  HERE_API_KEY: process.env.HERE_API_KEY || process.env.REACT_APP_HERE_API_KEY,
  // INFO we currently use freemium tier APP_ID / APP_CODE to keep support on long term restricted to some features functionalities only
  // https://my-air.atlassian.net/browse/MYP-2573
  HERE_APP_ID: process.env.HERE_APP_ID || process.env.REACT_APP_HERE_APP_ID,
  HERE_APP_CODE: process.env.HERE_APP_CODE || process.env.REACT_APP_HERE_APP_CODE,
  //
  AWS_APIGW_INVOKE_URL: process.env.AWS_APIGW_INVOKE_URL || process.env.REACT_APP_AWS_APIGW_INVOKE_URL
};



// WEBPACK FOOTER //
// ./src/constants.js